<template>
  <div class="svg-box">
    <svg width="100%" height="100%" version="1.1">
      <!--<line x1="30" y1="350" x2="2000" y2="350" style="stroke:red;stroke-width:20"></line>-->
      <!--<line x1="2000" y1="350" x2="800" y2="1300" style="stroke:red;stroke-width:20"></line>-->
      <!--<line x1="800" y1="1300" x2="30" y2="1300" style="stroke:red;stroke-width:20"></line>-->
      <!--<line v-for="(item,index) in tmpLines" :key="index"-->
      <!--v-if="tmpI>=index"-->
      <!--:x1="item.x1" :y1="item.y1" :x2="item.x2" :y2="item.y2"-->
      <!--style="stroke:red;stroke-width:20"></line>-->
      <line v-for="(item,index) in lines" :key="index"
            v-if="index<=stepCurrent"
            :x1="item.x1" :y1="item.y1" :x2="item.x2" :y2="item.y2"
            style="stroke:red;stroke-width:2">
      </line>
    </svg>
    <span v-for="(item,index) in svgPoints11" :key="index" class="el-icon-s-open"
          :style="{left:item.x+'px',top:item.y+'px',transform:'scale('+(1/scale)+')'}"></span>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        timeStep: 50,
        intervaler: '',
        lines: [],
        stepCount: 0,
        stepCurrent: 0,
        tmpLines: [
          {x1: 100, y1: 100, x2: 200, y2: 100},
          {x1: 200, y1: 100, x2: 300, y2: 100},
          {x1: 300, y1: 100, x2: 400, y2: 100},
          {x1: 400, y1: 100, x2: 500, y2: 100},
          {x1: 500, y1: 100, x2: 600, y2: 100},
        ],
        tmpI: 0
      }
    },

    props: ["svgPoints", "scale", "points"],

    computed: {},

    watch: {
      points: {
        handler(newValue, oldValue) {
          for (let i = 0; i < newValue.length; i++) {
            if (oldValue[i] !== newValue[i]) {
              console.error(newValue)
            }
          }
        },
        deep: true
      }
    },

    created() {
      console.error('--------------------');
      //console.error(this.svgPoints);
//      setInterval(() => {
//        if (this.tmpI < 10) {
//          this.tmpI += 1;
//        }
//      }, 100);
      let lines = [];
      this.svgPoints11 = [  //传进来的数据
        {x: 30, y: 350, millisecond: 1589617050645},
        {x: 2000, y: 350, millisecond: 1589617052645},
        {x: 800, y: 1300, millisecond: 1589617055645},
        {x: 30, y: 1300, millisecond: 1589617066645}
      ];
      return;
      let sls = [...this.points];
      this.stepCount = (sls[sls.length - 1].millisecond - sls[0].millisecond) / this.timeStep;
      console.log(sls[1].millisecond - sls[0].millisecond);
      lines.push({x1: sls[0].x, y1: sls[0].y, x2: sls[0].x, y2: sls[0].y});
      for (let i = 0; i < (sls.length - 1); i++) {
        sls[i].endmillisecond = sls[i + 1].millisecond;
        sls[i].endx = sls[i + 1].x;
        sls[i].endy = sls[i + 1].y;
        sls[i].step = Math.ceil((sls[i + 1].millisecond - sls[i].millisecond) / this.timeStep);
        sls[i].xStep = (sls[i + 1].x - sls[i].x) / sls[i].step;
        sls[i].yStep = (sls[i + 1].y - sls[i].y) / sls[i].step;
      }

      let i = 0;
      while (i < sls.length - 1) {
        let j = 1;
        while (j <= sls[i].step) {
          lines.push({
            x1: sls[i].x + sls[i].xStep * (j - 1),
            y1: sls[i].y + sls[i].yStep * (j - 1),
            x2: sls[i].x + sls[i].xStep * j,
            y2: sls[i].y + sls[i].yStep * j,
          });
          j++;
        }
        i++;
      }
      console.log(lines);
      this.lines = lines;

    },

    updated() {
      //console.log(this.points);
      //console.error(11111111111)
    },

    methods: {
      lineAnimationStop(){
        if (this.intervaler) {
          clearInterval(this.intervaler);
          this.intervaler = null;
        }
      },
      lineAnimationStart(){
        clearInterval(this.intervaler);
        this.intervaler = null;
        this.intervaler = setInterval(() => {
          this.stepCurrent += 1;
        }, this.timeStep);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../common/less/variable.less";

  .animate-stop {
    animation-play-state: paused;
  }

  .svg-box {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgba(0, 0, 0, 0.05);
    span {
      position: absolute;
      z-index: 88;
      font-size: 24px;
      margin: -12px 0 0 -12px;
      color: red;
      display: block;
      width: 24px;
      height: 24px;
    }
  }
</style>
